import React, { FC, ReactNode, useContext, useEffect, useState } from 'react'
import ApiContext from './ApiContext'
import SectorContext from './SectorContext'
import { SectorModel, getSectorLabel } from '../domain/sector.model'

interface Props {
  children: ReactNode
}

const SectorContextProvider: FC<Props> = ({ children }) => {
  const { getSectors, getSectorLocales } = useContext(ApiContext)
  const [sectors, setSectors] = useState<SectorModel[]>([])
  const [supportedLocales, setSupportedLocales] = useState<string[]>(['en', 'fr'])

  const refreshSectors = () => {
    getSectors().then(setSectors).catch(() => {})
  }

  useEffect(() => {
    getSectorLocales().then(setSupportedLocales).catch(() => {})
    refreshSectors()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getSectorLabelById = (id: string, lang: string): string => {
    const sector = sectors.find((s) => s.id === id)
    if (sector) return getSectorLabel(sector, lang)
    return id
  }

  return (
    <SectorContext.Provider value={{ sectors, supportedLocales, getSectorLabelById, refreshSectors }}>
      {children}
    </SectorContext.Provider>
  )
}

export default SectorContextProvider
